<template>
  <el-form-item :label="i18nt('designer.setting.displayStyle')">
    <el-radio-group v-model="optionModel.displayStyle">
      <el-radio label="inline" value="inline">{{ i18nt('designer.setting.inlineLayout') }}</el-radio>
      <el-radio label="block" value="block">{{ i18nt('designer.setting.blockLayout') }}</el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { toRefs } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'displayStyle-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
    };
  },
};
</script>

<style scoped></style>
